import SphereAnimation from './sphere/SphereAnimation.js';
import DelaunayAnimation from './delaunay/NetworkAnimation.js';

/*
 * =====================================================
 * WYBÓR ANIMACJI HERO
 * =====================================================
 *
 * 'sphere'   - przestrzenna chmura punktów
 * 'delaunay' - sieć Delaunay
 *
 */

//const ANIMATION = 'delaunay';
const ANIMATION = 'sphere';

let animation = null;

/*
 * Zwraca tylko kontener.
 * Nie uruchamia animacji.
 */
export default function Animation() {

    return `
        <div id="animation-canvas"></div>
    `;

}

/*
 * Uruchamiana po wyrenderowaniu strony.
 */
export function initAnimation() {

    const container = document.getElementById('animation-canvas');

    if (!container) {
        return;
    }

    /*
     * Usuń poprzednią animację
     */

    if (animation) {

        animation.dispose();

        animation = null;

    }

    /*
     * Wybierz animację
     */

    switch (ANIMATION) {

        case 'sphere':

            animation = new SphereAnimation(
                'animation-canvas'
            );

            break;

        case 'delaunay':

            animation = new DelaunayAnimation(
                'animation-canvas'
            );

            break;

        default:

            console.error(
                `Unknown animation: ${ANIMATION}`
            );

            return;

    }

    /*
     * Start
     */

    animation.init();

}
